export default __webpack_public_path__ + "static/media/styled-components-logo.9749998b.png";